import { useMemo } from 'react';

import { TableState } from 'react-table';

import { isNullOrUndefined } from '@adsk/alloy-react-helpers';

type ControlledTableState<D extends Record<string, unknown>> = Partial<
  Pick<
    TableState<D>,
    'pageIndex' | 'pageSize' | 'totalDataCount' | 'selectedRowIds'
  >
>;

const createControlledStateHook = <D extends Record<string, unknown>>({
  pageIndex,
  pageSize,
  totalDataCount,
  selectedRowIds,
}: ControlledTableState<D>) => {
  // Called on each Table render to ensure internal table state matches the controlled
  // state.
  // https://react-table.tanstack.com/docs/faq#how-can-i-manually-control-the-table-state
  const useControlledState = (state: TableState<D>) => {
    return useMemo(
      () => ({
        ...state,
        ...(isNullOrUndefined(pageIndex) ? {} : { pageIndex }),
        ...(isNullOrUndefined(pageSize) ? {} : { pageSize }),
        ...(isNullOrUndefined(totalDataCount) ? {} : { totalDataCount }),
        ...(isNullOrUndefined(selectedRowIds) ? {} : { selectedRowIds }),
      }),
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [state, pageIndex, pageSize, totalDataCount, selectedRowIds]
    );
  };
  return useControlledState;
};

export default createControlledStateHook;
